import * as React from 'react';

import { HistoryOutlined, ExpandAltOutlined } from '@ant-design/icons';

import { ChangeHistoryModal } from './ChangeHistoryModal';

type ProductData = {
  id: number;
  title: string;
};

type ProductChangeHistoryProps = {
  productData: ProductData;
};

export const ProductChangeHistory = ({ productData }: ProductChangeHistoryProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div
        id='quickview-change-history'
        onClick={handleOpenModal}
        className='border-grey-100 text-text-secondary flex w-full cursor-pointer items-center justify-between rounded-sm border bg-white px-4 py-3'
      >
        <span className='flex items-center gap-2 text-sm leading-none font-semibold'>
          <HistoryOutlined style={{ fontSize: 16 }} /> Histórico de alterações
        </span>
        <ExpandAltOutlined className='text-xs text-[#999]' />
      </div>
      <ChangeHistoryModal isOpen={isModalOpen} handleClose={handleCloseModal} productData={productData} />
    </>
  );
};
